<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-twoColumn-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <accordion-input :open="true">
                        <template #label>

                            <div class="flex flex-col">
                                <div class="font-medium text-gray-600">Toon informatie van product</div>
                                <div class="mt-1 text-xs text-gray-500">Toon downloads en FAQ vanaf product</div>
                            </div>

                        </template>
                        <template #content>

                            <v-select
                                :options="products"
                                label="name"
                                v-model="options.product"
                                :reduce="product => product.id"
                            >

                                <div slot="no-options">Geen opties</div>

                            </v-select>
                            
                        </template>
                    </accordion-input>

                </div>

                <div slot="Design">
                    <CommonInputs
                        :options="options"
                    />
                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from "axios";
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AccordionInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input';

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        AccordionInput,
    },

    data() {
        return {
            products: [],
        };
    },

    created() {
        this.loadProducts();
    },

    methods: {

        async loadProducts() {
            // Load artists.
            this.products = (await axios.get(this.adminUrlPrefix + '/products')).data;
        },

    },

}

</script>

<style lang="scss">

.canvas-blocks-custom-twoColumn-BlockPanel {

    .vs__dropdown-menu {
        position: static;
    }

}

</style>
